import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { PeepingLogo } from "@/components/PeepingLogo";
import { homeFor } from "@/lib/api";

function FullLoader() {
  return (
    <div data-testid="route-loader" className="min-h-screen flex flex-col items-center justify-center bg-[#080808] gap-6">
      <PeepingLogo className="w-44" />
      <div className="w-32 h-[2px] bg-white/10 overflow-hidden rounded-full">
        <div className="h-full w-full bg-gradient-to-r from-[#6a00ff] to-[#d42be8] animate-pulse" />
      </div>
    </div>
  );
}

function RoleRoute({ roles, children }) {
  const { user } = useAuth();
  if (user === null) return <FullLoader />;
  if (user === false) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={homeFor(user)} replace />;
  return children;
}

export const ProtectedRoute = ({ children }) => <RoleRoute>{children}</RoleRoute>;
export const CreatorRoute = ({ children }) => <RoleRoute roles={["creator"]}>{children}</RoleRoute>;
export const AdminRoute = ({ children }) => <RoleRoute roles={["super_admin"]}>{children}</RoleRoute>;
